import React, { useState, useEffect } from "react"
import Icon from "../../../components/AppIcon"
import { Card } from "../../../components/ui/card"
import { Badge } from "../../../components/ui/badge"
import { getCourseLearners } from "../../../utils/courseDetailHelpers"

const LearnersTab = ({ orgId, courseId }) => {
  const [enrollments, setEnrollments] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (!orgId || !courseId) return
    getCourseLearners(orgId, courseId).then(({ enrollments: list }) => {
      setEnrollments(list || [])
      setLoading(false)
    })
  }, [orgId, courseId])

  if (loading) return <div className="p-8 text-center text-sm text-muted-foreground">Loading learners...</div>

  if (enrollments?.length === 0) {
    return (
      <Card className="p-12 text-center dark:bg-transparent">
        <Icon name="Users" size={24} className="text-muted-foreground mx-auto mb-3" />
        <p className="text-sm text-muted-foreground">No learners enrolled yet.</p>
      </Card>
    )
  }

  return (
    <Card className="p-0 dark:bg-transparent overflow-hidden">
      <div className="divide-y divide-border">
        {enrollments?.map((enrollment) => (
          <div key={enrollment?.enrollmentId || enrollment?.userId} className="flex items-center gap-4 px-4 py-3">
            <div className="w-9 h-9 rounded-full bg-accent/10 flex items-center justify-center shrink-0">
              <Icon name="User" size={15} className="text-accent" />
            </div>
            <div className="flex-1 min-w-0">
              {/* Showing raw userId — swap in a real name once a user-profile lookup exists */}
              <p className="text-sm font-medium text-foreground truncate">{enrollment?.userId}</p>
              {enrollment?.cohortName && <p className="text-xs text-muted-foreground">{enrollment?.cohortName}</p>}
            </div>
            <div className="hidden sm:flex items-center gap-6 text-xs text-muted-foreground shrink-0">
              <span>{enrollment?.progressPercent || 0}% complete</span>
              <span>{enrollment?.lessonsCompleted || 0} lessons</span>
              <span>{enrollment?.pointsEarned || 0} pts</span>
            </div>
            <Badge variant={enrollment?.status === "active" ? "success" : "warning"} className="shrink-0">
              {enrollment?.status === "active" ? "Active" : enrollment?.status || "Unknown"}
            </Badge>
          </div>
        ))}
      </div>
    </Card>
  )
}

export default LearnersTab